import numeral from 'numeral';

export default {
    methods: {
        /**
         * @param  {String} isoDate
         * @return {String}
         */
        receiptDateFormat(isoDate) {
            var getZone = localStorage.getItem('getZone');
            var getZoneoffset = localStorage.getItem('getZoneoffset');
            if (getZoneoffset == null || getZone == null) {
                var getZoneoffset = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone_offset
                    : null;
                var getZone = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone
                    : null;
                if (getZoneoffset == null || getZone == null) {
                    var getZoneoffset = '+08:00';
                    var getZone = 'Asia/Kuala_Lumpur';
                }
            }
            var getid = localStorage.getItem('active_outlet');
            var utc = moment.utc(isoDate);
            var stillUtc = moment.utc(isoDate).toDate(getZone);
            var local = moment(isoDate)
                .local()
                .format('YYYY-MMM-DD HH:mm:ss');

            // var zoneTime = stillUtc.toLocaleString('en-US', {
            //     timeZone: getZone,
            // }); // based on zone
            var offset = moment(utc).utcOffset(getZoneoffset); //based on offset

            if (localStorage.getItem('timezones') === 'UTC') {
                var timezone = utc;
            } else if (localStorage.getItem('timezones') === 'Local') {
                var timezone = offset;
            }
            return moment(timezone)
                .format('DD MMM YYYY HH:mm:ss')
                .toUpperCase();
        },
        receiptDateFormatModal(date, offset) {
            if (offset == null || offset == '') {
                var offset = window.slurp.auth.franchise
                    ? window.slurp.auth.franchise.timezone_offset
                    : null;
                if (offset == null || offset == '') {
                    var offset = '+08:00';
                }
            }
            var utc = moment.utc(date);
            var timezone = moment(utc).utcOffset(offset); //based on offset
            return moment(timezone)
                .format('DD MMM YYYY HH:mm:ss')
                .toUpperCase();
        },

        /**
         * @param  {Object} receipt
         * @return {String}
         */
        receiptNumberFormat(receipt) {
            let ids = [
                receipt.sequence_number,
                receipt.receipt_number.substr(0, 6),
            ];

            return ids.filter(s => s != null).join(' / ');
        },

        /**
         * @param  {Object} orderProduct
         * @return {String}
         */
        orderProductName(orderProduct) {
            if (orderProduct.variant !== null)
                return `${orderProduct.name} (${orderProduct.variant.name})`;

            return orderProduct.name;
        },

        /**
         * @param  {Object} orderProduct
         * @return {Float}
         */
        orderProductPrice(orderProduct) {
            let productPrice = 0;
            let actual;

            if (!_.isNull(orderProduct.variable_price)) {
                productPrice = orderProduct.variable_price;
            }

            if (!_.isNull(orderProduct.variant_price)) {
                productPrice = orderProduct.variant_price;
            }

            if (!_.isNull(orderProduct.unit_price)) {
                productPrice = orderProduct.unit_price;
            }

            if (orderProduct.refund) {
                actual = productPrice;
            } else {
                actual = productPrice * orderProduct.quantity;
            }

            return numeral(actual).format('0,0.00');
        },

        /**
         * @param  {Object} modifier
         * @param  {Object} orderProduct
         * @return {String}
         */
        orderProductModifierName(modifier) {
            if (modifier.modifier_id != null) return modifier.modifier.name;

            return modifier.name;
        },

        /**
         * @param  {Object} modifier
         * @param  {Object} orderProduct
         * @return {Float}
         */
        orderProductModifierPrice(modifier, orderProduct) {
            let orderModifier;
            let amount;
            let totalAmount;
            const productQty = orderProduct.quantity;
            const actualModifierQty = modifier.quantity * orderProduct.quantity;

            // get modifier mode from modifier record
            if (modifier.modifier_id != null) {
                orderModifier = modifier.modifier;
            } else {
                // get mode from custom modifier created in central
                orderModifier = modifier;
            }

            // multiply only if the mode is topup or deduct
            if (orderModifier.mode == 1 || orderModifier.mode == 2) {
                totalAmount = numeral(
                    modifier.amount * actualModifierQty,
                ).format();
            } else {
                totalAmount = modifier.amount;
            }

            switch (orderModifier.mode) {
                case 1:
                    // type topup
                    amount = '+ ' + totalAmount;
                    break;
                // type deduct
                case 2:
                    amount = '- ' + totalAmount;
                    break;
                // type discount
                case 3:
                    amount = `- ${numeral(totalAmount).format('0,0.[00]')}%`;
                    break;
                default:
                    // type instruction
                    amount = '0.00';
            }

            return amount;
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/receipt.js